import type { StyleProp, ViewStyle } from 'react-native';
import { useResponsiveLayout } from './useResponsiveLayout';

const DESKTOP_SHEET_STYLE: ViewStyle = {
  maxWidth: 720,
  marginHorizontal: 'auto',
};

export function useDesktopSheetStyle(baseStyle?: StyleProp<ViewStyle>): StyleProp<ViewStyle> {
  const { isMobile } = useResponsiveLayout();
  if (isMobile) return baseStyle;
  return baseStyle ? [baseStyle, DESKTOP_SHEET_STYLE] : DESKTOP_SHEET_STYLE;
}
